export default __webpack_public_path__ + "static/media/page-login-bg.9f82e157.svg";